import { GetEventResponse, PutEventType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { createTripMutation } from './createTripCrudResource'

export const useUpdateEvent = createTripMutation<
	GetEventResponse,
	{ tripId: string; eventId: string; eventData: PutEventType }
>({
	mutationFn: async ({ tripId, eventId, eventData }) => {
		const response = await api.patch<GetEventResponse>(
			`/trips/${tripId}/events/${eventId}`,
			eventData,
		)
		return response.data
	},
	invalidate: ({ tripId }) => [queryKeys.events(tripId)],
})
